import React from 'react';

/**
 * Barre de sous-onglets légère pour les onglets fusionnés (SEO & contenu,
 * Performance & technique, Visibilité IA). Un seul niveau, lisible.
 *
 * @param {{ items: {key,label,icon?}[], active: string, onChange: (k)=>void }} props
 */
export default function SubNav({ items, active, onChange, className = '' }) {
  return (
    <div className={`inline-flex gap-1 p-1 rounded-xl bg-blue-gray-50 border border-blue-gray-100 ${className}`}>
      {items.map((item) => {
        const isActive = active === item.key;
        const Icon = item.icon;
        return (
          <button
            key={item.key}
            type="button"
            onClick={() => onChange(item.key)}
            className={`flex items-center gap-1.5 px-3.5 py-1.5 rounded-lg text-sm font-medium transition ${
              isActive
                ? 'bg-white text-accent shadow-sm'
                : 'text-blue-gray-600 hover:text-blue-gray-900'
            }`}
          >
            {Icon && <Icon size={14} />}
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
